import { Footer } from '../components/Footer.js';
import { Nav } from '../components/Nav.js';
import { TabletDevice } from '../components/TabletDevice.js';

const STEPS = [
  {
    n: '01',
    title: 'Réception & branchement',
    desc: "La tablette arrive préconfigurée. Branchement secteur, connexion Wi-Fi — c'est tout. L'écran s'allume sur l'horloge.",
  },
  {
    n: '02',
    title: 'Créer le foyer',
    desc: 'Depuis votre téléphone, vous créez le foyer de votre proche : son prénom, son fuseau horaire, la taille des caractères.',
  },
  {
    n: '03',
    title: 'Inviter la famille',
    desc: "Envoyez une invitation à chaque proche. Ils reçoivent un e-mail, installent l'app en 2 minutes, et peuvent déjà envoyer un premier mot.",
  },
  {
    n: '04',
    title: 'Au quotidien',
    desc: "Agenda, rappels, messages et photos apparaissent automatiquement sur l'écran. Votre proche n'a rien à faire.",
  },
] as const;

const TIMELINE = [
  {
    time: '09:42',
    label: "L'horloge affiche l'heure en grand. Mamie voit le jour, la date, le bonjour.",
  },
  {
    time: '10:00',
    label:
      "L'alerte du rendez-vous kiné s'affiche. Elle touche « J'ai vu » — la famille est notifiée.",
  },
  {
    time: '10:28',
    label:
      "Léa envoie une photo depuis l'école. Elle apparaît en plein écran pendant le diaporama.",
  },
  {
    time: '14:18',
    label:
      "Thomas écrit « Bon appétit Mamie ». Le bandeau rose s'affiche, elle appuie sur le gros bouton.",
  },
  {
    time: '22:00',
    label: "L'écran passe en mode nuit — horloge douce, pas de son. Elle s'endort tranquille.",
  },
] as const;

export function CommentCaMarche() {
  return (
    <>
      <Nav active="how" />
      <main>
        <div className="page-intro container">
          <div className="eyebrow">Comment ça marche</div>
          <h1>
            Prêt en <em>vingt minutes</em>.
          </h1>
          <p className="lede">
            Quatre étapes, une fois. Ensuite c'est votre proche qui profite — sans rien faire.
          </p>
        </div>

        <section className="section">
          <div className="container">
            <div className="section-comment">
              <div className="steps">
                {STEPS.map((s) => (
                  <div key={s.n} className="step">
                    <div className="step-n">{s.n}</div>
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                  </div>
                ))}
              </div>
              <div className="steps-cta">
                <a href="/inscription" className="btn btn-primary btn-lg btn-arrow">
                  Créer un foyer
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="section ink">
          <div className="container">
            <div className="section-head">
              <div className="meta">
                <div className="eyebrow">Une journée</div>
                <p className="small">du réveil au coucher</p>
              </div>
              <h2>
                Chez Mamie,
                <em> sans effort</em>.
              </h2>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '56px',
                alignItems: 'start',
              }}
            >
              <div>
                {TIMELINE.map(({ time, label }) => (
                  <div
                    key={time}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '60px 1fr',
                      gap: '20px',
                      marginBottom: '28px',
                    }}
                  >
                    <div
                      style={{
                        fontFamily: 'Fraunces Variable, serif',
                        fontWeight: 500,
                        fontSize: '18px',
                        color: 'var(--terracotta)',
                        paddingTop: '2px',
                      }}
                    >
                      {time}
                    </div>
                    <p
                      style={{
                        margin: 0,
                        fontSize: '15px',
                        lineHeight: 1.55,
                        color: 'oklch(0.85 0.014 78)',
                      }}
                    >
                      {label}
                    </p>
                  </div>
                ))}
              </div>
              <div>
                <TabletDevice time="14:18" day="vendredi" date="23 mai" hi="beau temps." />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
